/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listingbuttonssaved2Inputs */

const en_listingbuttonssaved2 = /** @type {(inputs: Listingbuttonssaved2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buttons saved`)
};

const de_listingbuttonssaved2 = /** @type {(inputs: Listingbuttonssaved2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Knöpfe gespeichert`)
};

/**
* | output |
* | --- |
* | "Buttons saved" |
*
* @param {Listingbuttonssaved2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const listingbuttonssaved2 = /** @type {((inputs?: Listingbuttonssaved2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listingbuttonssaved2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listingbuttonssaved2(inputs)
	return de_listingbuttonssaved2(inputs)
});
export { listingbuttonssaved2 as "listingButtonsSaved" }